const MaporalTheme = {
    images : {
        loginLogo: "/img/maporal/login-logo.png",
        whiteLogo: "/img/maporal/login-logo.png",
        favicon: "/img/maporal/favicon.ico",
        leftMenuLogo: "/img/maporal/logo-only.png",

        touchIconIphone: "/img/touch-icon-iphone.png",
        touchIconIpad:"/img/touch-icon-ipad.png",
        touchIconIphoneRetina: "/img/touch-icon-iphone-retina.png",
        touchIconIpadRetina: "/img/touch-icon-ipad-retina.png",
        appleTouchStartupImage: "/img/apple-touch-startup-image"
    },
    css: [
        "/themes/valsabor/valsabor.css"
    ],
    strings: {
        title: "Maporal - We are the Pork Producers"
    }
}

export default MaporalTheme;